import Burger from './navigation-hamburger';
import Expander from './expander';
import EPiServerFormsCaptchaCustom from './episerverformscaptcha';

export default (function($) {
  this.init = () => {
    this.setVars();
    this.modifyDOM();
    this.addEvents();
    Burger();
    Expander();
    EPiServerFormsCaptchaCustom();
  };

  this.setVars = () => {
  };

  this.modifyDOM = () => {


    var swiper = new Swiper('.swiper-container', { 
      effect: 'fade',
      loop: false,
      autoplay: 8000,
      pagination: '.swiper-navigation',
      paginationType: 'custom',
      paginationCurrentClass: 'swiper-navigation__item--active',
      fade: {
        crossFade: true
      },
      onSlideChangeStart(swiper) {
        var $currentSlideNumber = swiper.activeIndex;
        var $currentSlideItem = $('.swiper-navigation').find("[data-slide='" + $currentSlideNumber + "']");
        $currentSlideItem.addClass('swiper-navigation__item--active');
        $currentSlideItem.siblings().removeClass('swiper-navigation__item--active');
      }
    });
  };

  this.addEvents = () => {
    this.eventHandlers.calcSwiperHeight();
    $('.timeline__item__read-more').on('click', this.eventHandlers.expandHistoryItem);
  };

  this.eventHandlers = {

    calcSwiperHeight: function () {
      var $hero = $('.swiper-container');
      $hero.height($(window).height() - 289);
      $hero.addClass('loaded');
    },

    expandHistoryItem: function() {
      $(this).hide();
      $(this).siblings('.timeline__item__content').addClass('expanded');
    }

  };

  this.helpers = {
  };

  return this.init;
}).call({}, jQuery);
